import { $t } from "@/plugins/i18n";
const Layout = () => import("@/layout/index.vue");

export default [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
    meta: {
      title: $t("menus.hslogin"),
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/iframe/jushu-platform",
    name: "JushuPlatformIframe",
    component: () => import("@/views/CustomLayout/index.vue"), // 直接使用对方系统的页面组件
    // component: () => import("@/views/jushuPlatform/index.vue"), // 直接使用对方系统的页面组件
    meta: {
      title: "聚数平台",
      keepAlive: true,
      showLink: false
    }
  },
  // {
  //   path: "/iframe/temu-sales",
  //   name: "TemuSales",
  //   component: () => import("@/views/TemuSales/index.vue"), // 直接使用对方系统的页面组件
  //   meta: {
  //     title: "TEMU-销售管理",
  //     keepAlive: true,
  //     showLink: false,
  //   }
  // },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/login/register.vue"),
    meta: {
      title: $t("menus.hslogin"),
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/selectFactory",
    name: "selectFactory",
    component: () => import("@/views/login/selectFactory.vue"),
    meta: {
      title: $t("menus.hslogin"),
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/redirect",
    component: Layout,
    meta: {
      title: $t("status.hsLoad"),
      showLink: false,
      rank: 102
    },
    children: [
      {
        path: "/redirect/:path(.*)",
        name: "Redirect",
        component: () => import("@/layout/redirect.vue")
      }
    ]
  }
] as Array<RouteConfigsTable>;
